import axios from "axios"

export default {
    async ActualLocation(data){
        const response = await axios.post('/api/seyir/vehicleactuallocations',data)
        return response
    },
    async LocationLogs(date){
        const response = await axios.get(`/api/seyir/getlocationlogs/${date}`)
        return response
    },
    async LocationLogsForVehicle(plate,startDate,endDate){
        const response = await axios.get(`/api/seyir/getlocationlogsforvehicle/${plate}/${startDate}/${endDate}`)
        return response
    },
    async LocationLogsForVehicleByDate(plate,date){
        const response = await axios.get(`/api/seyir/getlocationlogsforvehiclebydate/${plate}/${date}`)
        return response
    },
    async GetPerformanceReport(date,starHour,endHour){
        const response = await axios.get(`/api/seyir/getperformancereport/${date}/${starHour}/${endHour}`)
        return response
    },
    async GetDateRangePerformanceReport(startDate,endDate,starHour,endHour){
        const response = await axios.get(`/api/seyir/getdaterangeperformancereport/${startDate}/${endDate}/${starHour}/${endHour}`)
        return response
    },
    async GetVehicleDetailReport(date){
        const response = await axios.get(`/api/seyir/getvehicledetailreport/${date}`)
        return response
    },
    async GetAreaReport(date){
        const response = await axios.get(`/api/seyir/getareareport/${date}`)
        return response
    },
    async GetAreaReportAndEntrances(startDate,endDate){
        const response = await axios.get(`/api/seyir/getareareportandareaentrances/${startDate}/${endDate}`)
        return response
    },
    async GetVehicles(){
        const response = await axios.get(`/api/seyir/getvehicles`)
        return response
    }
}